// -----------------
// IMPORTS
// -----------------
import { createApp, markRaw, watch } from 'vue'
import { createPinia } from 'pinia'
import createPersistedState from 'pinia-plugin-persistedstate'
import { plugin as formKitPlugin, defaultConfig as formKitDefaultConfig } from '@formkit/vue'
import configformKit from '../formkit.config.js'

import '@/scss/styles.scss'
import * as bootstrap from 'bootstrap'
import axios from 'axios'
import Swal from 'sweetalert2'
import Pusher from 'pusher-js'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth.js'

// -----------------
// GLOBAL CONFIGURATIONS
// -----------------
window.bootstrap = bootstrap

window.axios = axios
window.axios.defaults.baseURL = import.meta.env.VITE_API_URL
window.axios.defaults.headers.common['Accept'] = 'application/json'
window.axios.defaults.headers.common['Content-Type'] = 'application/json' // (ojo aquí, tenías typo)
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.withCredentials = true

window.Pusher = Pusher

window.swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success float-end',
    cancelButton: 'btn btn-danger mx-3',
  },
  buttonsStyling: false,
})

// -----------------
// CREATE APP
// -----------------
const app = createApp(App)

// -----------------
// CONFIGURE PINIA
// -----------------
const pinia = createPinia()
pinia.use(({ store }) => {
  store.router = markRaw(router)
})
pinia.use(createPersistedState)
app.use(pinia)

// -----------------
// CONFIGURE TOAST
// -----------------
const toastOptions = {
  position: POSITION.BOTTOM_RIGHT,
  pauseOnHover: true,
  showCloseButtonOnHover: true,
}
app.use(Toast, toastOptions)

// -----------------
// ERROR HANDLER
// -----------------
app.config.errorHandler = (err, vm, info) => {
  console.error('Error:', err)
  console.error('Vue component:', vm)
  console.error('Additional info:', info)
}

// -----------------
// SOCKET AUTH (ECHO)
// -----------------
const authStore = useAuthStore()

watch(
  () => authStore.token,
  (newToken) => {
    if (newToken) {
      authStore.initializeEcho()
    } else if (authStore.echo) {
      authStore.echo.disconnect()
    }
  },
)

// Si el usuario ya tiene sesión iniciada, inicializar Echo
if (authStore.token) {
  authStore.initializeEcho()
}

// -----------------
// LOAD DYNAMIC ROUTES THEN MOUNT APP
// -----------------
axios
  .get(`${import.meta.env.VITE_API_URL}/api/v1/auth/optionsmenu`)
  .then((response) => {
    const rutasDinamicas = response.data.data

    rutasDinamicas.forEach((route) => {
      const dynamicRoute = {
        path: route.path,
        name: route.component,
        component: () => import(`@/views/GestionTesoreria/GestionTesoreriaMainView.vue`),
        meta: {
          iconClass: 'fa-solid fa-users',
          title: route.component,
          menuName: route.component,
          showSidebar: true,
          permission: 'dashboard',
        },
      }
      router.addRoute(dynamicRoute)
    })

    // Ahora que están todas las rutas cargadas:
    app.use(formKitPlugin, formKitDefaultConfig(configformKit))
    app.use(router)
    app.mount('#app')
  })
  .catch((error) => {
    console.error('Error al cargar rutas dinámicas:', error)

    // Igual montamos la app para que no se quede bloqueada si falla la API
    app.use(formKitPlugin, formKitDefaultConfig(configformKit))
    app.use(router)
    app.mount('#app')
  })
